import ShapeSelector from '../../../../atoms/ShapeSelector/ShapeSelector';
import Accordion from '../../../Accordion/Accordion';
import StyledOrientation from './styles';
import Props from './typings';

export const getOrientationTitle = (selectedOrientations) => {
  return {label: selectedOrientations, count: selectedOrientations.length > 0 ? 1 : 0};
};

const Orientation = ({
  selected,
  orientationCallback,
  collapsible = false,
  defaultCollapsed = false,
}: Props) => {
  const title = 'Orientation';
  const subtitle = 'Any form you might need.';

  const onShapeClick = (shape) => {
    if (selected.includes(shape)) {
      orientationCallback([]);
    } else {
      orientationCallback([shape]);
    }
  };

  const fragmentBody = () => <ShapeSelector selected={selected} callback={onShapeClick} />;

  const collapsibleFragment = () => (
    <Accordion title={title} subtitle={subtitle} defaultCollapsed={defaultCollapsed}>
      {fragmentBody()}
    </Accordion>
  );

  const fragment = () => (
    <StyledOrientation>
      <h4>{title}</h4>

      <p>{subtitle}</p>

      {fragmentBody()}
    </StyledOrientation>
  );

  return collapsible === true ? collapsibleFragment() : fragment();
};

export default Orientation;
